import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { apiEndPoints } from "../../ApiServices/config";
import toast from "react-hot-toast";
import { postApi } from "../../ApiServices/api";
import { useParams, useNavigate } from "react-router-dom";
export const useResetPassword = () => {
  const params = useParams();
  const navigate = useNavigate();

  // Validation schema
  const resetPasswordValidation = yup.object().shape({
    password: yup
      .string()
      .required("Please Enter your password")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    confirm_password: yup
      .string()
      .required("Please Confirm your password")
      .oneOf([yup.ref("password"), null], "Passwords must match"),
  });

  // Form hook
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(resetPasswordValidation),
  });

  // Form submission handler
  const onSubmit = async (data) => {
    try {
      const response = await postApi(apiEndPoints.isValidResetToken, {
        token: params.email_reset_token,
      });

      if (response?.data?.status === 0) {
        toast.error(response?.data?.message);
      } else {
        data.user = response?.data?.user;
        data.token = params.email_reset_token;

        const result = await postApi(apiEndPoints.resetPassword, data);

        if (result?.data?.status === 1) {
          toast.success(result?.data?.message);
          navigate("/login");
        }
      }
    } catch (error) {
      toast.error(`Password Reset failed: ${error}`);
    }
  };

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
  };
};
